import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  Menu,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useFormik } from "formik";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { makeStyles } from "@mui/styles";
import FileUploadService from "../../../components/services/FileUploadService";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import DialogAddFac from "../components/DialogAddFac";
import * as yup from "yup";
import mime from "mime";
import { saveAs } from "file-saver";
import { get } from "lodash";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});

export default function EditQuotation() {
  const classes = useStyles();
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  let { id } = useParams();
  const data_params = { id: id };
  const { Duplicate } = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [company, setCompany] = useState("");
  const [branch, setBranch] = useState("");
  const [ServiceType, setServiceType] = useState("");
  const [TripType, setTripType] = useState("Round Trip");
  const [TripDirection, setTripDirection] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [companyDataFilter, setCompanyDataFilter] = useState([]);
  const [branchDataFilter, setBranchDataFilter] = useState([]);
  const [CustomerList, setCustomerList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [Commoditylist, setCommodilist] = useState([]);
  const [CustomerListFilter, setCustomerListFilter] = useState([]);
  const [Currency, setCurrency] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [PriceList, setPriceList] = useState([]);
  const [ContainerList, setContainerList] = useState([]);
  const [Submitting, setSubmitting] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [SUM, setSUM] = useState("");
  const [Discount, setDiscount] = useState("");
  const [CusName, setCusName] = useState("");
  const [QuotationDraftNo, setQuotationDraftNo] = useState("");
  const [QuotationNumber, setQuotationNumber] = useState("");
  const [QuotationId, setQuotationId] = useState("");
  const [EmpList, setEmpList] = useState([]);
  const [StatusQuo, setStatusQuo] = useState(null);
  // const [FacList, setFacList] = useState([]);
  const [OpenAddFac, setOpenAddFac] = useState(false);
  const [PriceDiscount, setPriceDiscount] = useState(null);
  const [OriginalFac, setOriginalFac] = useState([]);
  // const [factory, setFactory] = useState([]);
  const [Fac, setFac] = useState([]);
  const [FacSelected, setFacSelected] = useState([]);
  const [Vat, setVat] = useState([]);
  const [Vattest, setVatestt] = useState("");
  const [Draft, setDraft] = useState("");
  const [pdfFileGen, setPDFFile] = useState([]);
  const [Conlist, setConlist] = useState([]);
  const [loading, setLoading] = useState(false);
  // const validationSchema = yup.object({
  //   customer: yup.object({
  //     cusId: yup.string().required("cusId is required"),
  //   }),
  //   serviceRoute: yup.object({
  //     locationFrom: yup.string().required("locationFrom is required"),
  //     groupFrom: yup.string().required("groupFrom is required"),
  //     locationTo: yup.string().required("locationTo is required"),
  //     groupTo: yup.string().required("groupTo is required"),
  //   }),
  // });

  const getlistCurrency = async () => {
    try {
      const d = await api.get("api/master/currency").then((response) => {
        setCurrency(response.data);

        // console.log(response);
      });
    } catch (e) {}
  };

  const getlistcom = async () => {
    try {
      const d = await api.get("api/master/commodity").then((response) => {
        setCommodilist(response.data);

        // console.log(response);
      });
    } catch (e) {}
  };
  const getlistvat = async () => {
    try {
      const d = await api.get("api/master/Vatvalue");
      const result_ = d?.data?.data;
      setVat(result_);
    } catch (e) {}
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      quoDate: "",
      Commodity: "",
      Currency: "",
      customer: {
        cusId: "",
        cusCode: "",
      },
      factory: {
        facId: "",
        Status: true,
      },
      cusAddress: "",
      tel: "",
      fax: "",
      email: "",
      contractName: "",
      remark: "",
      quoDateFrom: "",
      quoDateTo: "",

      serviceRoute: {
        locationFrom: null,
        groupFrom: "",
        locationTo: null,
        groupTo: "",
      },
      note: "",
      status: "",
      saleId: "",
      saleName: "",

      priceId: "",
      PriceNo: "",
      containerId: "",
      ContainerTypeName: "",
      qty: "",
      amount: "",
      discount: "",
      total: "",
      grandTotal: "",
      serviceno: "",
      Vatvalue: "",
      VatID: "",
    },
    // validationSchema: validationSchema,

    onSubmit: (values) => {
      console.log(values);
      const status = 1;
      const createId = EmpId;
      const detail = detailList
        .filter((x) => !x.delete)
        .map((data) => ({
          serviceId: data.ServiceId,
          containerId: data.containerId,
          qty: +data.qty,
          amount: +data.amount,
          discount: 0,
          total: data.total,
          Serviceno: data.Serviceno,
          Servicename: data.Servicename,
          Vattype: "EX",
          Vatvalue: data.Vatvalue,
          VatAmount: data.grandTotal,
          grandTotal: data.grandTotal,
          Status: true,
        }));

      const Fac = FacSelected.filter((x) => x.selected).map((x) => ({
        facId: x.FactoryId,
        quotationDetailFactoryId:
          StatusQuo !== 4
            ? x?.QuotationDetailFactoryId
            : ""
            ? x?.QuotationDetailFactoryId
            : null,
      }));
      const _fac = Fac.map((x) => ({ ...x, createId: EmpId }));
      setSubmitting(true);
      setTimeout(() => {
        const data = {
          quoDate: !values.quoDate
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(values.quoDate).format("YYYY-MM-DD"),
          cusId: values.customer.cusId,
          Factory: Fac,
          tel: values.tel,
          fax: values.fax,
          email: values.email,
          contractName: values.contractName,
          remark: values.remark,
          quoDateFrom: !values.quoDateFrom
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(values.quoDateFrom).format("YYYY-MM-DD"),
          quoDateTo: !values.quoDateTo
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(values.quoDateTo).format("YYYY-MM-DD"),
          locationFrom: values.serviceRoute.locationFrom.LocationId,
          groupFrom: values.serviceRoute.groupFrom,
          locationTo: values.serviceRoute.locationTo.LocationId,
          groupTo: values.serviceRoute.groupTo,
          note: values.note,
          saleId: values.saleId,
          commodityId: values.Commodity,
          currencyId: values.Currency,
          // saleName: values.saleName,
          Detail: detail,
          CompanyId: company || null,
          BranchId: branch || null,
          ServiceType: ServiceType || null,
          TripType: TripType || "Round Trip",
          TripDirection: TripType === "One-Way" ? (ServiceType === "Import" || ServiceType === "Export" ? ServiceType : null) : null,
          status,
          createId,
        };
        const dataUpdate = {
          id: QuotationId,
          QuotationId: QuotationId,
          quoDate: !values.quoDate
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(values.quoDate).format("YYYY-MM-DD"),
          cusId: values.customer.cusId,
          Factory: _fac,
          tel: values.tel,
          fax: values.fax,
          email: values.email,
          contractName: values.contractName,
          remark: values.remark,
          quoDateFrom: !values.quoDateFrom
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(values.quoDateFrom).format("YYYY-MM-DD"),
          quoDateTo: !values.quoDateTo
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(values.quoDateTo).format("YYYY-MM-DD"),
          locationFrom: values.serviceRoute.locationFrom.LocationId,
          groupFrom: values.serviceRoute.groupFrom,
          locationTo: values.serviceRoute.locationTo?.LocationId,
          groupTo: values.serviceRoute.groupTo,
          note: values.note,
          saleId: values.saleId,
          commodityId: values.Commodity,
          currencyId: values.Currency,
          CompanyId: company || null,
          BranchId: branch || null,
          ServiceType: ServiceType || null,
          TripType: TripType || "Round Trip",
          TripDirection: TripType === "One-Way" ? (ServiceType === "Import" || ServiceType === "Export" ? ServiceType : null) : null,
          // saleName: values.saleName,
          Detail: detail,
          status,
          createId,
        };
        if (detailList.length > 0 && FacSelected.length > 0) {
          if (StatusQuo == 1) {
            api
              .post("api/quotation/update", dataUpdate)
              .then((respose) => {
                const MySwal = withReactContent(Swal);

                MySwal.fire({
                  icon: "success",
                  didOpen: () => {
                    MySwal.clickConfirm();
                  },
                }).then(() => {
                  return MySwal.fire(
                    "สำเร็จ!",
                    "แก้ไขใบเสนอราคาสำเร็จ !",
                    "success"
                  ).then((result) => {
                    if (result.isConfirmed) {
                      history.push("/CustomerSupport/Quotation");
                    }
                  });
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } else if (!StatusQuo || StatusQuo === 4) {
            // console.log(data)
            api
              .post("/api/quotation/create", data)
              .then((respose) => {
                const MySwal = withReactContent(Swal);

                MySwal.fire({
                  icon: "success",
                  didOpen: () => {
                    MySwal.clickConfirm();
                  },
                }).then(() => {
                  return MySwal.fire(
                    "สำเร็จ!",
                    "เพิ่มใบเสนอราคาสำเร็จ !",
                    "success"
                  ).then((result) => {
                    if (result.isConfirmed) {
                      history.push("/CustomerSupport/Quotation");
                    }
                  });
                });
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          console.log("err");
        }

        setSubmitting(false);
      }, 400);
    },
  });

  const isError = (fieldName) => {
    console.log(fieldName);
    return (
      get(formik.touched, fieldName, false) &&
      Boolean(get(formik.errors, fieldName, false))
    );
  };
  const getDataCompanyList = async () => {
    try {
      const res = await api.get("api/master/company");
      setCompanyData(res.data.data.filter((e) => e.Status === true));
      setCompanyDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  const getDataBranchList = async () => {
    try {
      const res = await api.get("api/master/branch");
      // console.log(data);
      setBranchData(res.data.data.filter((e) => e.Status === true));
      setBranchDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };

  const getCustomerList = async () => {
    const params = {
      cusType: 2,
    };
    try {
      const result = await api.post("api/customer/list", params);
      const _result = result.data;
      setCustomerList(_result);
      setCustomerListFilter(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const getEmployeesList = async () => {
    try {
      const result = await api.get("api/master/employee");
      const _result = result.data.data;
      setEmpList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const getGroupList = async () => {
    try {
      const result = await api.get("api/master/group");
      const _result = result.data.data;
      setGroupList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const getLocationList = async () => {
    try {
      const result = await api.get("api/master/location");
      const _result = result.data.data;
      setLocationList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const getPriceList = async () => {
    try {
      const result = await api.get("api/master/Service");
      const _result = result?.data?.data;
      setPriceList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };
  const getConList = async () => {
    try {
      const result = await api.get("api/master/commodity/container");
      const _result = result?.data;
      setConlist(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  // console.log(ContainerList);
  const getAmountfromID = async () => {
    const id = formik.values.priceId;
    try {
      const result = await api.post("api/price/detail", { id });
      setContainerList(result?.data[0]?.Detail);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  // const AmountContainer = (e, newValue) => {
  //   if (newValue) {
  //     formik.setFieldValue("containerId", e.target.value);
  //     formik.setFieldValue("ContainerTypeName", newValue.props.children);
  //   } else {
  //     formik.setFieldValue("containerId", "");
  //     formik.setFieldValue("ContainerTypeName", "");
  //   }
  //   const _Amount = ContainerList
  //     ? ContainerList.filter((x) => x.ContainerId === e.target.value).map(
  //         (x) => x.Amount
  //       )
  //     : 0;

  //   formik.setFieldValue("amount", +_Amount[0]);

  //   const _total = +_Amount[0] * formik.values.qty;
  //   const _totalDiscount = _total - formik.values.discount;

  //   formik.setFieldValue("grandTotal", _totalDiscount);
  //   formik.setFieldValue("total", _total);
  // };

  // const getContainerList = async () => {
  //   try {
  //     const result = await api.get("api/container/list");
  //     const _result = result.data;
  //     setContainerList(_result);
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };
  const getDataQuoDetail = async () => {
    try {
      const data = await api
        .post("api/quotation/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              if (!Duplicate) {
                setStatusQuo(res.Status);
              } else {
                setStatusQuo(Duplicate);
              }
              setDraft(res);
              setQuotationId(res.QuotationId);
              setQuotationDraftNo(res.QuotationDraftNo);
              setQuotationNumber(res.QuotationNo);
              setCompany(res?.CompanyId);
              setBranch(res?.BranchId);
              setServiceType(res?.ServiceType || res?.TripDirection || "");
              setTripType(res?.TripType || "Round Trip");
              setTripDirection(res?.TripDirection || "");
              formik.setFieldValue("quoDate", res.QuotationDate);
              setCusName(res.customer.CustomerName);
              formik.setFieldValue("customer.cusId", res.customer.CustomerId);
              formik.setFieldValue(
                "customer.cusCode",
                res.customer.CustomerCode
              );
              formik.setFieldValue("cusAddress", res.customer.CustomerAddress);
              formik.setFieldValue("tel", res.Telephone);
              formik.setFieldValue("fax", res.Fax);
              formik.setFieldValue("email", res.Email);
              formik.setFieldValue("contractName", res.ContractName);
              formik.setFieldValue("remark", res.Remark);
              formik.setFieldValue("quoDateFrom", res.QuotationDateFrom);
              formik.setFieldValue("quoDateTo", res.QuotationDateTo);
              formik.setFieldValue("saleId", res.SaleName);
              formik.setFieldValue(
                "serviceRoute.locationFrom",
                res.typeLocationFrom
              );
              formik.setFieldValue("serviceRoute.groupFrom", res.GroupFrom);
              formik.setFieldValue(
                "serviceRoute.locationTo",
                res.typeLocationTo
              );
              formik.setFieldValue("serviceRoute.groupTo", res.GroupTo);
              formik.setFieldValue("note", res.InternalNote);
              formik.setFieldValue("Commodity", res.CommodityId);
              formik.setFieldValue("Currency", res.CurrencyId);
              // formik.setFieldValue("saleName", res.SaleName);
              setIsLoading(false);

              setDetailList(
                res.detail.map((x) => ({
                  ...x,
                  delete: false,
                  DetailNo: x.QuotationDetailId,
                  ServiceId: x.ServiceId,
                  containerId: x?.ContainerTypeId,
                  ContainerTypeName: x.containerType?.ContainerTypeName,
                  qty: +x.Qty,
                  amount: +x.Amount,
                  discount: 0,
                  total: +x.TotalAmount,
                  Serviceno: x.Serviceno,
                  Servicename: x.Servicename,
                  Vattype: "EX",
                  Vatvalue: x.Vatvalue,
                  VatAmount: x.grandTotal,
                  grandTotal: x.VatAmount,
                  Status: true,
                }))
              );

              if (res.quotationfactory) {
                const facResult = res.quotationfactory.map((x) => ({
                  selected: true,
                  FactoryAddress: x.MSTFactory.FactoryAddress,
                  FactoryName: x.MSTFactory.FactoryName,
                  FactoryId: x.FactoryId,
                  QuotationDetailFactoryId: x.QuotationDetailFactoryId,
                }));
                // setFacList(facResult);
                // SelectedFac(facResult); //Function
                setFacSelected(facResult);
              } else {
                // setFacList([]);
                setFacSelected([]);
              }

              if (res.detail) {
                const DetailResult = res.detail.map((x) => ({
                  ...x,
                  delete: false,
                  DetailNo: x.QuotationDetailId,
                }));

                const sum = DetailResult.map((item) => item.TotalAmount).reduce(
                  (prev, cur) => {
                    // prev = 0 [1,2,3] index = 0
                    return prev + parseInt(cur, 10);
                  },
                  0
                );
                const discount = DetailResult.map(
                  (item) => item.VatAmount
                ).reduce((prev, cur) => {
                  return +prev + +cur;
                });

                setSUM(sum);
                setDiscount(discount);
                setPriceDiscount(discount.toString());
              }
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Container");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const getFactoryList = async () => {
    try {
      const result = await api.get("api/factory/list");
      const _result = result.data;
      setOriginalFac(_result.filter((e) => e.Status === true));
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const changeStatusButton = async (StatusNO) => {
    setTimeout(() => {
      const body = {
        id: QuotationId,
        Status: StatusNO,
      };
      if (StatusNO === 0) {
        api
          .post("api/quotation/change", body)
          .then((respose) => {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "สำเร็จ!",
                "ยกเลิกใบเสนอราคาสำเร็จ !",
                "success"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/CustomerSupport/Quotation");
                }
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (StatusNO === 2) {
        api
          .post("api/quotation/change", body)
          .then((respose) => {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "สำเร็จ!",
                "อนุมัติใบเสนอราคาสำเร็จ !",
                "success"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/CustomerSupport/Quotation");
                }
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (StatusNO === 3) {
        api
          .post("api/quotation/change", body)
          .then((respose) => {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "สำเร็จ!",
                "จบใบเสนอราคาสำเร็จ !",
                "success"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/CustomerSupport/Quotation");
                }
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }

      setSubmitting(false);
    }, 400);
  };

  // const SelectedFac = async (facResult) => {
  //   try {
  //     await api.get("api/factory/list").then((res) => {
  //       if (res) {
  //         const _result = res.data.map((x) => ({ ...x, selected: false }));
  //         const facIds = facResult.map((x) => x.FactoryId);

  //         const _facList = [..._result]; // clone deep

  //         for (let f of _facList) {
  //           f.selected = facIds.indexOf(f.FactoryId) > -1 ? true : false;
  //         }

  //         setFacList([..._facList]);
  //       }
  //     });
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };

  const printk = async () => {
    try {
      api
        .post("api/quotation/detail/pdf", data_params)
        .then((respose) => {
          // console.log(respose);
          respose?.data.map((x) => {
            setPDFFile(x?.path);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  // const saveEditFactory = async () => {
  //   const facNew = factory
  //     .filter((x) => x.selected === true)
  //     .map((x) => ({ facId: x.facId }));
  //   const body = { quotationId: QuotationId, createId: EmpId, factory: facNew };
  //   try {
  //     api
  //       .post("api/quotation/factory/update", body)
  //       .then((respose) => {
  //         const MySwal = withReactContent(Swal);

  //         MySwal.fire({
  //           icon: "success",
  //           didOpen: () => {
  //             MySwal.clickConfirm();
  //           },
  //         }).then(() => {
  //           return MySwal.fire(
  //             "สำเร็จ!",
  //             "แก้ไขโรงงานสำเร็จ !",
  //             "success"
  //           ).then((result) => {
  //             if (result.isConfirmed) {
  //               history.push("/CustomerSupport/Quotation");
  //             }
  //           });
  //         });
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  useEffect(() => {
    getCustomerList();
    getGroupList();
    getLocationList();
    getPriceList();
    getlistvat();
    getConList();
    // getContainerList();
    getEmployeesList();
    getFactoryList();
    getlistcom();
    getlistCurrency();
    getDataCompanyList();
    getDataBranchList();
    if (id) {
      getDataQuoDetail();
      printk();
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (formik.values.priceId) {
      getAmountfromID();
    }
  }, [formik.values.priceId]);

  const handleCloseDialog = () => {
    formik.setFieldValue("priceId", "");
    formik.setFieldValue("containerId", "");
    formik.setFieldValue("qty", "");
    formik.setFieldValue("amount", "");
    formik.setFieldValue("discount", "");
    formik.setFieldValue("total", "");
    formik.setFieldValue("grandTotal", "");

    setOpen(false);
  };

  const handleCloseDialogFac = (props) => {
    setOpenAddFac(props);
  };

  const handleSaveDialog = () => {
    const data = [
      ...detailList,
      {
        createId: EmpId,
        ServiceId: formik.values.priceId,
        PriceNo: formik.values.PriceNo,
        Servicename: formik.values.PriceNo,
        Serviceno: formik.values.serviceno,
        containerId: formik.values.containerId,
        ContainerTypeName: formik.values.ContainerTypeName,
        qty: formik.values.qty,
        amount: formik.values.amount,
        discount: formik.values.discount ? formik.values.discount : 0,
        total: formik.values.total,
        grandTotal: formik.values.grandTotal,
        delete: false,
        Vatvalue: formik.values.Vatvalue,
        VatAmount: formik.values.grandTotal,
        commodityId: formik.values.Commodity,
        DetailNo: detailList.length + 1,
      },
    ];
    const sum = data
      .filter((x) => !x.delete)
      .map((item) => item.total)
      .reduce((prev, cur) => {
        // prev = 0 [1,2,3] index = 0
        return prev + parseInt(cur, 10);
      }, 0);
    const discount = data
      .filter((x) => !x.delete)
      .map((item) => item.discount)
      .reduce((prev, cur) => {
        return prev + parseInt(cur, 10);
      }, 0);
    const grandTotal = data
      .filter((x) => !x.delete)
      .map((item) => item.grandTotal)
      .reduce((prev, cur) => {
        return +prev + +cur;
      });

    setDetailList(data);
    setSUM(sum);
    setDiscount(discount);
    setPriceDiscount(grandTotal.toString());
    handleCloseDialog();
  };

  const handleSetFacList = (facList) => {
    // setFacList(facList);
    const SelectedFac = facList.filter((x) => x.selected === true);

    setFacSelected(SelectedFac);
  };

  const handleDeleteFac = (Fac, index) => {
    const _FacList = FacSelected.map((item, index2) =>
      item.FactoryId === Fac.FactoryId
        ? {
            ...item,
            selected: false,
          }
        : item
    );
    // const _FacList = FacList.map((item, index2) =>
    //   item.FactoryId === Fac.FactoryId
    //     ? {
    //       ...item,
    //       selected: false,
    //     }
    //     : item
    // );

    const SelectedFac = _FacList.filter((x) => x.selected === true);

    setFacSelected(SelectedFac);
    // setFacList(_FacList);
  };

  const handleDeleteFacNew = (Fac, index) => {
    const _FacList = FacSelected.map((item, index2) =>
      item.FactoryId === Fac.FactoryId
        ? {
            ...item,
            selected: false,
          }
        : item
    );

    setFacSelected(_FacList);
  };

  const handleDeleteRow = (Row, index) => {
    const RowList = detailList.map((item, index2) =>
      item.DetailNo === Row.DetailNo
        ? {
            ...item,
            delete: true,
          }
        : item
    );
    const _RowList = RowList.filter((x) => !x.delete);

    const Sum = SUM - Row.total;
    const discount = Discount - +Row.discount;
    const priceDiscount = +PriceDiscount - Row.grandTotal;

    setDetailList(_RowList);
    setSUM(Sum);
    setDiscount(discount);
    setPriceDiscount(priceDiscount.toString());
  };

  // console.log(factory)
  const handleAddFactory = (e, newValue) => {
    const fac = {
      facId: e.target.value,
      FacName: newValue.props.children,
      selected: true,
    };
    setFacSelected([...FacSelected, fac]);
    // setFactory([...factory, fac]);
    // setFac(e.target.value);
  };

  return (
    <div>
      <Card
        variant="outlined"
        style={{
          padding: "20px",
          margin: "25px",
          height: "86vh",
          maxHeight: "86vh",
          overflow: "auto",
        }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ใบเสนอราคา
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Quotation
            </Typography>
            {Draft != "" ? (
              <Typography sx={{ fontSize: "16px", color: "#80c340" }}>
                #
                {Draft.QuotationNo != null
                  ? Draft.QuotationNo
                  : Draft.QuotationDraftNo}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Customer Support </Typography>
            <Typography className="textcolorBule">
              <span>&nbsp;</span> / Quotation
            </Typography>
            <Typography>
              <span>&nbsp;</span> /{" "}
              {!id ? "Create Quotation" : "Edit Quotation"}
            </Typography>
          </Grid>
        </Grid>
        {isLoading ? (
          "loading..."
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid sx={{ padding: "40px 70px 40px 70px" }}>
              {id ? (
                <Grid container item xs={12}>
                  {StatusQuo == 0 ? (
                    <>
                      <span className="material-icons-outlined textcolorRed">
                        close
                      </span>
                      <h6 className="textcolorRed">REJECTED</h6>
                    </>
                  ) : StatusQuo == 2 ? (
                    <>
                      <span className="material-icons-outlined textcolorBule">
                        done_all
                      </span>
                      <h6 className="textcolorBule">APPROVED</h6>
                    </>
                  ) : StatusQuo == 3 ? (
                    <>
                      <span className="material-icons-outlined textcolorgreen">
                        done
                      </span>
                      <h6 className="textcolorgreen" style={{ marginLeft: 10 }}>
                        DONE
                      </h6>
                    </>
                  ) : null}
                </Grid>
              ) : null}

              <Grid container spacing={3} sx={{ marginBottom: "10px" }}>
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel>Company</InputLabel>
                    <Select
                      name="Company"
                      label="Company"
                      value={company || ""}
                      InputLabelProps={{ shrink: true }}
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                      onChange={(e) => {
                        setCompany(e.target.value);
                        setBranch("");
                        if (e.target.value) {
                          setBranchDataFilter(
                            branchData.filter(
                              (item) => item?.CompanyId === e.target.value
                            )
                          );
                          setCustomerListFilter(
                            CustomerList.filter(
                              (item) => item?.CompanyId === e.target.value
                            )
                          );
                        } else {
                          setBranchDataFilter(branchData);
                          setCustomerListFilter(CustomerList);
                          setFacSelected([]);
                          // setFactory([])
                          formik.setFieldValue("customer.cusId", "");
                          formik.setFieldValue("customer.cusCode", "");
                          formik.setFieldValue("contractName", "");
                          formik.setFieldValue("email", "");
                          formik.setFieldValue("tel", "");
                          formik.setFieldValue("fax", "");
                          formik.setFieldValue("cusAddress", "");
                        }
                      }}
                    >
                      <MenuItem value={""}>None</MenuItem>
                      {companyData?.map((item) => {
                        return (
                          <MenuItem value={item?.CompanyId}>
                            {item?.CompanyName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel>Branch</InputLabel>
                    <Select
                      name="Branch"
                      label="Branch"
                      value={branch || ""}
                      InputLabelProps={{ shrink: true }}
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                      onChange={(e) => {
                        setBranch(e.target.value);

                        if (e.target.value) {
                          setCustomerListFilter(
                            CustomerList.filter(
                              (item) => item?.BranchId === e.target.value
                            )
                          );
                        } else {
                          setCompany("");
                          setBranchDataFilter(branchData);
                          setCustomerListFilter(CustomerList);
                          setFacSelected([]);
                          // setFactory([])
                          formik.setFieldValue("customer.cusId", "");
                          formik.setFieldValue("customer.cusCode", "");
                          formik.setFieldValue("contractName", "");
                          formik.setFieldValue("email", "");
                          formik.setFieldValue("tel", "");
                          formik.setFieldValue("fax", "");
                          formik.setFieldValue("cusAddress", "");
                        }
                      }}
                    >
                      <MenuItem value={""}>None</MenuItem>
                      {branchDataFilter?.map((item) => {
                        return (
                          <MenuItem value={item?.BranchId}>
                            {item?.BranchName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disabled={
                            StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                          }
                          inputFormat="dd/MM/yyyy"
                          name="quoDate"
                          value={
                            formik.values.quoDate
                              ? formik.values.quoDate
                              : new Date()
                          }
                          onChange={(newValue) => {
                            formik.setFieldValue("quoDate", newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Quotation Date"
                              style={{
                                // marginTop: "10px",
                                // marginBottom: "10px",
                                width: "100%",
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        classes={{
                          root: !formik.values.Currency
                            ? classes.customOutline
                            : null,
                        }}
                      >
                        <InputLabel id="Currency">Currency</InputLabel>
                        <Select
                          name="Currency"
                          // id="groupFrom"

                          // error={isError("serviceRoute.groupFrom")}
                          value={formik.values.Currency}
                          label="Currency"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                          }}
                          onChange={formik.handleChange}
                          disabled={
                            StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                          }
                        >
                          {Currency.map((data) => (
                            <MenuItem value={data.CurrencyId}>
                              {data.CurrencyName}({data.CurrencyCode})
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                {id && StatusQuo === 1 ? (
                  <Grid item xs={12} sm={6}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="QuotationDraftNo"
                          label="Draft Quotation Number"
                          variant="outlined"
                          disabled
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                            backgroundColor: "#EAECEF",
                          }}
                          InputLabelProps={{ shrink: true }}
                          value={QuotationDraftNo}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl
                          fullWidth
                          classes={{
                            root: !formik.values.Commodity
                              ? classes.customOutline
                              : null,
                          }}
                        >
                          <InputLabel id="Commodity">Commodity</InputLabel>
                          <Select
                            name="Commodity"
                            // id="groupFrom"
                            // error={isError("serviceRoute.groupFrom")}
                            value={formik.values.Commodity}
                            label="Commodity"
                            style={{
                              width: "100%",
                              // marginTop: "10px",
                              // marginBottom: "10px",
                            }}
                            onChange={formik.handleChange}
                            disabled={
                              StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                            }
                          >
                            {Commoditylist.map((data) => (
                              <MenuItem value={data.CommodityId}>
                                {data.CommodityName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : id &&
                  (StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3) ? (
                  <>
                    {/* <Grid item xs={12} sm={3}>
                      <TextField
                        name="QuotationNumber"
                        label="Quotation Number"
                        variant="outlined"
                        disabled
                        style={{
                          width: "100%",
                          // marginTop: "10px",
                          // marginBottom: "10px",
                          backgroundColor: "#EAECEF",
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={QuotationNumber}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        classes={{
                          root: !formik.values.Commodity
                            ? classes.customOutline
                            : null,
                        }}
                      >
                        <InputLabel id="Commodity">Commodity</InputLabel>
                        <Select
                          name="Commodity"
                          // id="groupFrom"
                          // error={isError("serviceRoute.groupFrom")}
                          value={formik.values.Commodity}
                          label="Commodity"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                          }}
                          onChange={formik.handleChange}
                          disabled={
                            StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                          }
                        >
                          {Commoditylist.map((data) => (
                            <MenuItem value={data.CommodityId}>
                              {data.CommodityName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel>ServiceType</InputLabel>
                        <Select
                          name="ServiceType"
                          label="ServiceType"
                          value={ServiceType || ""}
                          InputLabelProps={{ shrink: true }}
                          disabled={
                            StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                          }
                          onChange={(e) => {
                            const v = e.target.value;
                            setServiceType(v);
                            // Transit / None ไม่มีทิศ -> บังคับ Round Trip (One-Way ต้องเป็น Import/Export)
                            if (v !== "Import" && v !== "Export") setTripType("Round Trip");
                          }}
                        >
                          <MenuItem value={""}>None</MenuItem>
                          <MenuItem value={"Import"}>Import</MenuItem>
                          <MenuItem value={"Export"}>Export</MenuItem>
                          <MenuItem value={"Transit"}>Transit</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel>Trip Type</InputLabel>
                        <Select
                          name="TripType"
                          label="Trip Type"
                          value={TripType || "Round Trip"}
                          InputLabelProps={{ shrink: true }}
                          disabled={StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3}
                          onChange={(e) => {
                            setTripType(e.target.value);
                          }}
                        >
                          <MenuItem value={"Round Trip"}>Round Trip</MenuItem>
                          <MenuItem value={"One-Way"} disabled={ServiceType !== "Import" && ServiceType !== "Export"}>One-Way</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        classes={{
                          root: !formik.values.Commodity
                            ? classes.customOutline
                            : null,
                        }}
                      >
                        <InputLabel id="Commodity">Commodity</InputLabel>
                        <Select
                          name="Commodity"
                          // id="groupFrom"
                          // error={isError("serviceRoute.groupFrom")}
                          value={formik.values.Commodity}
                          label="Commodity"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                          }}
                          onChange={formik.handleChange}
                          disabled={
                            StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                          }
                        >
                          {Commoditylist.map((data) => (
                            <MenuItem value={data.CommodityId}>
                              {data.CommodityName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel>ServiceType</InputLabel>
                        <Select
                          name="ServiceType"
                          label="ServiceType"
                          value={ServiceType || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const v = e.target.value;
                            setServiceType(v);
                            // Transit / None ไม่มีทิศ -> บังคับ Round Trip (One-Way ต้องเป็น Import/Export)
                            if (v !== "Import" && v !== "Export") setTripType("Round Trip");
                          }}
                        >
                          <MenuItem value={""}>None</MenuItem>
                          <MenuItem value={"Import"}>Import</MenuItem>
                          <MenuItem value={"Export"}>Export</MenuItem>
                          <MenuItem value={"Transit"}>Transit</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel>Trip Type</InputLabel>
                        <Select
                          name="TripType"
                          label="Trip Type"
                          value={TripType || "Round Trip"}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            setTripType(e.target.value);
                          }}
                        >
                          <MenuItem value={"Round Trip"}>Round Trip</MenuItem>
                          <MenuItem value={"One-Way"} disabled={ServiceType !== "Import" && ServiceType !== "Export"}>One-Way</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  {id && StatusQuo !== 4 ? (
                    <TextField
                      name="CusName"
                      label="Customer Name"
                      variant="outlined"
                      classes={{
                        root: !CusName ? classes.customOutline : null,
                      }}
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                        backgroundColor: "#EAECEF",
                      }}
                      disabled
                      InputLabelProps={{ shrink: true }}
                      value={CusName}
                    />
                  ) : StatusQuo == 4 ? (
                    <Autocomplete
                      name="CustomerName"
                      error={isError("customer.cusId")}
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      // freeSolo
                      options={CustomerListFilter}
                      value={
                        CustomerList?.find(
                          (v) => formik.values.customer.cusId === v.CustomerId
                        ) || null
                      }
                      getOptionLabel={(option) => {
                        return `${option.CustomerCode}: ${option.CustomerName}`;
                      }}
                      forcePopupIcon={true}
                      popupIcon={<SearchIcon />}
                      onChange={(e, newValue) => {
                        // console.log(e)
                        if (newValue) {
                          formik.setFieldValue(
                            "customer.cusId",
                            newValue.CustomerId
                          );
                          formik.setFieldValue(
                            "customer.cusCode",
                            newValue.CustomerCode
                          );
                          formik.setFieldValue(
                            "contractName",
                            newValue.CustomerContract
                          );
                          formik.setFieldValue("email", newValue.CustomerEmail);
                          formik.setFieldValue("tel", newValue.CustomerMobile);
                          formik.setFieldValue("fax", newValue.CustomerFax);
                          formik.setFieldValue(
                            "cusAddress",
                            newValue.CustomerAddress
                          );
                        } else {
                          formik.setFieldValue("customer.cusId", "");
                          formik.setFieldValue("customer.cusCode", "");
                          formik.setFieldValue("contractName", "");
                          formik.setFieldValue("email", "");
                          formik.setFieldValue("tel", "");
                          formik.setFieldValue("fax", "");
                          formik.setFieldValue("cusAddress", "");
                        }
                      }}
                      renderInput={(params) => {
                        const { inputProps, ...propsOter } = params;
                        const { value, ...remain } = inputProps;
                        return (
                          <TextField
                            {...propsOter}
                            {...remain}
                            inputProps={{...remain}}
                            label="Customer Name"
                            placeholder="Enter Customer Name"
                            InputLabelProps={{ shrink: true }}
                            required
                            value={
                              formik.values.customer.cusId
                                ? value
                                : ""
                            }

                            //   InputProps={{
                            //     endAdornment: (
                            //       <InputAdornment position="end">
                            //         <SearchIcon />
                            //       </InputAdornment>
                            //     ),
                            //   }}
                          />
                        );
                      }}
                    />
                  ) : (
                    <Autocomplete
                      id="CustomerName"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      // classes={{ root: !formik.values.customer.cusId ? classes.customOutline : null }}
                      freeSolo
                      options={CustomerListFilter}
                      value={
                        CustomerList?.find(
                          (v) => formik.values.customer.cusId === v.CustomerId
                        ) || null
                      }
                      getOptionLabel={(option) => {
                        return `${option.CustomerCode}: ${option.CustomerName}`;
                      }}
                      forcePopupIcon={true}
                      popupIcon={<SearchIcon />}
                      onChange={(e, newValue) => {
                        // mmmmmmmmmmmmmmmm
                        if (newValue) {
                          // setFactory(newValue.customerFactory)
                          setFacSelected(
                            newValue.customerFactory.map((x) => ({
                              ...x.factory,
                              selected: true,
                            }))
                          );
                          formik.setFieldValue(
                            "customer.cusId",
                            newValue.CustomerId
                          );
                          formik.setFieldValue(
                            "customer.cusCode",
                            newValue.CustomerCode
                          );
                          formik.setFieldValue(
                            "contractName",
                            newValue.CustomerContract
                          );
                          formik.setFieldValue("email", newValue.CustomerEmail);
                          formik.setFieldValue("tel", newValue.CustomerMobile);
                          formik.setFieldValue("fax", newValue.CustomerFax);
                          formik.setFieldValue(
                            "cusAddress",
                            newValue.CustomerAddress
                          );
                        } else {
                          setFacSelected([]);
                          // setFactory([])
                          formik.setFieldValue("customer.cusId", "");
                          formik.setFieldValue("customer.cusCode", "");
                          formik.setFieldValue("contractName", "");
                          formik.setFieldValue("email", "");
                          formik.setFieldValue("tel", "");
                          formik.setFieldValue("fax", "");
                          formik.setFieldValue("cusAddress", "");
                        }
                      }}
                      renderInput={(params) => {
                        const { inputProps, ...propsOter } = params
                        const { value, ...remain } = inputProps
                        return (
                          <TextField
                          {...propsOter}
                          {...remain}
                          inputProps={{...remain}}

                            value={
                              formik.values.customer.cusId
                                ? value
                                : ""
                            }
                            label="Customer Name"
                            classes={{
                              root: !formik.values.customer.cusId
                                ? classes.customOutline
                                : null,
                            }}
                            placeholder="Enter Customer Name"
                            InputLabelProps={{ shrink: true }}
                            required
                            //   InputProps={{
                            //     endAdornment: (
                            //       <InputAdornment position="end">
                            //         <SearchIcon />
                            //       </InputAdornment>
                            //     ),
                            //   }}
                          />
                        );
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="customer.cusCode"
                    label="Customer Code"
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      backgroundColor: "#EAECEF",
                    }}
                    disabled
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.customer.cusCode}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="cusAddress"
                    label="Address"
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      backgroundColor: "#EAECEF",
                    }}
                    disabled
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.cusAddress}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    name="tel"
                    label="Telephone"
                    variant="outlined"
                    disabled={
                      StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                    }
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.tel}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    name="fax"
                    label="Fax"
                    variant="outlined"
                    disabled={
                      StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                    }
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.fax}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="contractName"
                    label="Contract Name"
                    variant="outlined"
                    disabled={
                      StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                    }
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.contractName}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="email"
                    label="E-Mail"
                    variant="outlined"
                    type="email"
                    disabled={
                      StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                    }
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                <TextField
                  multiline
                  fullWidth
                  rows={4}
                  name="remark"
                  label="Remark"
                  variant="outlined"
                  disabled={StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3}
                  sx={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formik.values.remark}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      name="quoDateFrom"
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                      value={
                        formik.values.quoDateFrom
                          ? formik.values.quoDateFrom
                          : new Date()
                      }
                      onChange={(newValue) => {
                        formik.setFieldValue("quoDateFrom", newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Quotation Date From"
                          style={{
                            // marginTop: "10px",
                            // marginBottom: "10px",
                            width: "100%",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      name="quoDateTo"
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                      value={
                        formik.values.quoDateTo
                          ? formik.values.quoDateTo
                          : new Date()
                      }
                      onChange={(newValue) => {
                        formik.setFieldValue("quoDateTo", newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Quotation Date To"
                          style={{
                            // marginTop: "10px",
                            // marginBottom: "10px",
                            width: "100%",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="saleId">Sale Name</InputLabel>
                    <Select
                      name="saleId"
                      label="Sale Name"
                      variant="outlined"
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                      InputLabelProps={{ shrink: true }}
                      value={formik.values.saleId}
                      id="saleId"
                      style={{
                        width: "100%",
                        // marginTop: "10px",
                        // marginBottom: "10px",
                      }}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          formik.setFieldValue("saleId", newValue.props.value);
                          const SaleName = EmpList.find(
                            (data) => newValue.props.value === data.EmpId
                          );
                          formik.setFieldValue("saleName", SaleName.EmpName);
                        } else {
                          formik.setFieldValue("saleId", "");
                          formik.setFieldValue("saleName", "");
                        }
                      }}
                    >
                      {EmpList?.map((data) => (
                        <MenuItem value={data.EmpId}>{data.EmpName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={3} sx={{ marginTop: 4 }}>
                <Grid item xs>
                  <Typography className="textcolordarkblue" component="h1">
                    เพิ่มโรงงาน<span className="textcolorRed">&nbsp;*</span>
                  </Typography>
                </Grid>
                {StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3 ? null : (
                  <Grid item xs sx={{ justifyContent: "end", display: "flex" }}>
                    {FacSelected?.length <= 0 && (
                      <p style={{ color: "red", margin: 5 }}>
                        ** Please Add Factory **
                      </p>
                    )}

                    <Button
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                      }}
                      onClick={() => setOpenAddFac(true)}
                    >
                      + Add Factory
                    </Button>
                  </Grid>
                )}
                {/* {StatusQuo != ''   ? (
                <Grid
                  item
                  xs={12}
                  sm={5}
                  sx={{ justifyContent: "end", display: "flex" }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="saleId">Add Factory</InputLabel>
                    <Select
                      label="Add Factory"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={Fac}
                      id="facId"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={(e, newValue) => handleAddFactory(e, newValue)}
                    >
                      {OriginalFac?.map((data) => (
                        <MenuItem value={data.FactoryId}>
                          {data.FactoryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : ''} */}
              </Grid>

              <DialogAddFac
                DialodAddFac={OpenAddFac}
                DialogFacClose={handleCloseDialogFac}
                FacSelectedList={handleSetFacList}
                // FacReturnSelectedList={setOriginalFac}
                FacEditList={FacSelected}
                // FacEditList={FacList}
              />

              {FacSelected?.length > 0 && (
                <>
                  <TableContainer
                    sx={{
                      marginTop: 2,
                      marginBottom: 2,
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="5%">
                            #
                          </TableCell>
                          <TableCell align="center">
                            โรงงานที่เพิ่มใหม่
                          </TableCell>
                          <TableCell align="center"> </TableCell>
                        </TableRow>
                      </TableHead>
                      {FacSelected?.filter((x) => x?.selected !== false)?.map(
                        (data, index) => {
                          return (
                            <TableBody key={index}>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="left">
                                {data?.FactoryName}
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: "#FF0000",
                                    borderColor: "#FF0000",
                                  }}
                                  onClick={() =>
                                    handleDeleteFacNew(data, index)
                                  }
                                >
                                  ลบ
                                </Button>
                              </TableCell>
                            </TableBody>
                          );
                        }
                      )}
                    </Table>
                  </TableContainer>
                  <Divider />
                </>
              )}
              {/* 
            {factory?.length > 0 && (
              <>
                <TableContainer
                  sx={{
                    marginTop: 2,
                    marginBottom: 2,
                    maxHeight: "50vh",
                    overflow: "auto",
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" width="5%">
                          #
                        </TableCell>
                        <TableCell align="center">โรงงานที่เพิ่มใหม่</TableCell>
                        <TableCell align="center"> </TableCell>
                      </TableRow>
                    </TableHead>
                    {factory
                      ?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="left">{data?.factory?.FactoryName}</TableCell>
                            <TableCell align="center">
                              <Button
                                variant="outlined"
                                style={{
                                  color: "#FF0000",
                                  borderColor: "#FF0000",
                                }}
                                onClick={() => handleDeleteFacNew(data, index)}
                              >
                                ลบ
                              </Button>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                  </Table>
                </TableContainer>
                <Divider />
              </>
            )} */}
              {/* 
            {FacList?.length > 0 ? (
              <TableContainer
                sx={{
                  marginTop: 2,
                  marginBottom: 2,
                  maxHeight: "50vh",
                  overflow: "auto",
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" width="5%">
                        #
                      </TableCell>
                      <TableCell align="center">ชื่อโรงงาน</TableCell>
                      <TableCell align="center" width="50%">
                        ที่อยู่โรงงาน
                      </TableCell>
                      <TableCell align="center"> </TableCell>
                    </TableRow>
                  </TableHead>
                  {FacList?.filter((x) => x.selected).map((data, index) => {
                    return (
                      <TableBody key={index}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="left">{data.FactoryName}</TableCell>
                        <TableCell align="left" width="50%">
                          {data.FactoryAddress}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            style={{
                              color: "#FF0000",
                              borderColor: "#FF0000",
                            }}
                            onClick={() => handleDeleteFac(data, index)}
                            disabled={
                              StatusQuo == 0 ||
                              StatusQuo == 2 ||
                              StatusQuo == 3
                            }
                          >
                            ลบ
                          </Button>
                        </TableCell>
                      </TableBody>
                    );
                  })}
                </Table>
              </TableContainer>
            ) : null} */}

              <Grid item xs sx={{ marginTop: 4, marginBottom: "20px" }}>
                <Typography className="textcolordarkblue" component="h1">
                  เส้นทางการบริการ<span className="textcolorRed">&nbsp;*</span>
                </Typography>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  {/* <FormControl
                    fullWidth
                    classes={{
                      root: !formik.values.serviceRoute.locationFrom
                        ? classes.customOutline
                        : null,
                    }}
                  >
                    <InputLabel id="locationFrom">ต้นทาง</InputLabel>
                    <Select
                      name="serviceRoute.locationFrom"
                      id="locationFrom"
                      error={isError("serviceRoute.locationFrom")}
                      value={formik.values.serviceRoute.locationFrom}
                      label="ต้นทาง"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                      onChange={formik.handleChange}
                    >
                      {LocationList.map((data) => (
                        <MenuItem value={data.LocationId}>
                          {data.LocationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <Autocomplete
                    name="serviceRoute.locationFrom"
                    options={LocationList}
                    getOptionLabel={(option) => option?.LocationName}
                    classes={{
                      root: !formik.values.serviceRoute.locationFrom
                        ? classes.customOutline
                        : null,
                    }}
                    disabled={
                      StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                    }
                    onChange={(x, y) => {
                      // setFieldValue("InBoundGateOut", y);
                      formik.setFieldValue("serviceRoute.locationFrom", y);
                    }}
                    id="flat-demo"
                    value={formik.values.serviceRoute.locationFrom}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField required {...params} label="ต้นทาง" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    classes={{
                      root: !formik.values.serviceRoute.groupFrom
                        ? classes.customOutline
                        : null,
                    }}
                    required
                  >
                    <InputLabel id="groupFrom">
                      ประเภทการขนส่ง-ต้นทาง
                    </InputLabel>
                    <Select
                      name="serviceRoute.groupFrom"
                      id="groupFrom"
                      error={isError("serviceRoute.groupFrom")}
                      value={formik.values.serviceRoute.groupFrom}
                      label="ประเภทการขนส่ง-ต้นทาง"
                      style={{
                        width: "100%",
                        // marginTop: "10px",
                        // marginBottom: "10px",
                      }}
                      onChange={formik.handleChange}
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                    >
                      {GroupList.map((data) => (
                        <MenuItem value={data.GroupId}>
                          {data.GroupName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  {/* <FormControl
                    fullWidth
                    classes={{
                      root: !formik.values.serviceRoute.locationTo
                        ? classes.customOutline
                        : null,
                    }}
                  >
                    <InputLabel id="select_status-label">ปลายทาง</InputLabel>
                    <Select
                      name="serviceRoute.locationTo"
                      id="locationTo"
                      error={isError("serviceRoute.locationTo")}
                      value={formik.values.serviceRoute.locationTo}
                      label="ต้นทาง"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={formik.handleChange}
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                    >
                      {LocationList.map((data) => (
                        <MenuItem value={data.LocationId}>
                          {data.LocationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <Autocomplete
                    name="serviceRoute.locationTo"
                    options={LocationList}
                    getOptionLabel={(option) => option?.LocationName}
                    classes={{
                      root: !formik.values.serviceRoute.locationTo
                        ? classes.customOutline
                        : null,
                    }}
                    onChange={(x, y) => {
                      // setFieldValue("InBoundGateOut", y);
                      formik.setFieldValue("serviceRoute.locationTo", y);
                    }}
                    id="flat-demo"
                    disabled={
                      StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                    }
                    value={formik.values.serviceRoute.locationTo}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField required {...params} label="ปลายทาง" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    classes={{
                      root: !formik.values.serviceRoute.groupTo
                        ? classes.customOutline
                        : null,
                    }}
                    required
                  >
                    <InputLabel id="groupTo">ประเภทการขนส่ง-ปลายทาง</InputLabel>
                    <Select
                      name="serviceRoute.groupTo"
                      id="groupTo"
                      error={isError("serviceRoute.groupTo")}
                      value={formik.values.serviceRoute.groupTo}
                      label="ประเภทการขนส่ง-ปลายทาง"
                      style={{
                        width: "100%",
                        // marginTop: "10px",
                        // marginBottom: "10px",
                      }}
                      onChange={formik.handleChange}
                      disabled={
                        StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3
                      }
                    >
                      {GroupList.map((data) => (
                        <MenuItem value={data.GroupId}>
                          {data.GroupName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3} sx={{ marginTop: 4 }}>
                <Grid item xs>
                  <Typography className="textcolordarkblue" component="h1">
                    รายละเอียดบริการ
                    <span className="textcolorRed">&nbsp;*</span>
                  </Typography>
                </Grid>
                {StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3 ? null : (
                  <Grid item xs sx={{ justifyContent: "end", display: "flex" }}>
                    {detailList.length <= 0 && (
                      <p style={{ color: "red", margin: 5 }}>
                        ** Please Add Row **
                      </p>
                    )}
                    <Button
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                      }}
                      onClick={() => setOpen(true)}
                    >
                      + Add Row
                    </Button>
                  </Grid>
                )}
                <Dialog
                  fullWidth="sm"
                  maxWidth="lg"
                  open={open}
                  onClose={() => setOpen(false)}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {
                      <Typography
                        className="textcolordarkblue"
                        variant="h5"
                        component="h1"
                      >
                        ADD ROW
                      </Typography>
                    }
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <h5 className="textcolordarkblue">รายละเอียดการบริการ</h5>
                    </DialogContentText>
                    <Grid container spacing={3} sx={{ marginBottom: "20px" }}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="serviceno"
                          variant="outlined"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                          }}
                          name="serviceno"
                          value={formik.values.serviceno}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="detail">รายละเอียด</InputLabel>
                          <Select
                            name="priceId"
                            id="detail"
                            value={formik.values.priceId}
                            label="รายละเอียด"
                            style={{
                              width: "100%",
                              // marginTop: "10px",
                            }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                formik.setFieldValue("priceId", e.target.value);
                                const serviceno = PriceList.filter(
                                  (ser) => ser.ServiceId === e.target.value
                                )[0];
                                formik.setFieldValue(
                                  "serviceno",
                                  serviceno?.ServiceNo
                                );

                                formik.setFieldValue(
                                  "PriceNo",
                                  newValue.props.children
                                );
                              } else {
                                formik.setFieldValue("priceId", "");
                                formik.setFieldValue("PriceNo", "");
                              }
                            }}
                          >
                            {PriceList?.map((data) => (
                              <MenuItem value={data?.ServiceId}>
                                {data?.ServiceName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="container">ประเภทตู้</InputLabel>
                          <Select
                            name="containerId"
                            id="container"
                            value={formik.values.containerId}
                            label="ประเภทตู้"
                            style={{
                              width: "100%",
                              // marginTop: "10px",
                              // marginBottom: "10px",
                            }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                formik.setFieldValue(
                                  "containerId",
                                  e.target.value
                                );
                                formik.setFieldValue(
                                  "ContainerTypeName",
                                  newValue.props.children
                                );
                              } else {
                                formik.setFieldValue("containerId", "");
                                formik.setFieldValue("ContainerTypeName", "");
                              }
                            }}
                          >
                            {Conlist?.map((data) => (
                              <MenuItem value={data.ContainerTypeId}>
                                {data.ContainerTypeName} {data.Type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel>Vat</InputLabel>
                          <Select
                            label="vat"
                            value={formik.values.VatID}
                            style={{
                              width: "100%",
                              // marginTop: "10px",
                              // marginBottom: "10px",
                            }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                formik.setFieldValue("VatID", e.target.value);
                                formik.setFieldValue(
                                  "Vatvalue",
                                  newValue.props.children
                                );
                              } else {
                                formik.setFieldValue("Vatvalue", "");
                              }
                            }}
                          >
                            {Vat?.map((e) => (
                              <MenuItem value={e?.Vatvalueid}>
                                {e?.VatvalueNumber}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} sx={{ marginBottom: "20px" }}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="amount"
                          label="ค่าบริการ/ตู้"
                          variant="outlined"
                          type="number"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                          }}
                          onChange={(e) => {
                            formik.setFieldValue("amount", e.target.value);
                            const _total = +formik.values.qty * +e.target.value;

                            formik.setFieldValue("total", _total);
                            // formik.setFieldValue("grandTotal", _total);
                          }}
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.amount}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="qty"
                          label="ระบุจำนวนตู้"
                          variant="outlined"
                          type="number"
                          disabled={!formik.values.priceId}
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                          }}
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.qty}
                          onChange={(e) => {
                            if (e) {
                              formik.setFieldValue("qty", e.target.value);
                              const _total =
                                +formik.values.amount * +e.target.value;

                              const totalvat =
                                (+formik.values.amount +
                                  +formik.values.amount *
                                    (formik.values.Vatvalue / 100)) *
                                +e.target.value;

                              formik.setFieldValue("total", _total);
                              formik.setFieldValue("discount", "");
                              formik.setFieldValue(
                                "grandTotal",
                                totalvat.toFixed(2)
                              );
                            } else {
                              formik.setFieldValue("total", "");
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} sx={{ marginBottom: "20px" }}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="total"
                          label="ราคารวม"
                          variant="outlined"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                            backgroundColor: "#EAECEF",
                          }}
                          disabled
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.total}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          name="grandTotal"
                          label="ราคาหลังรวม VAT"
                          variant="outlined"
                          type="number"
                          style={{
                            width: "100%",
                            // marginTop: "10px",
                            // marginBottom: "10px",
                            backgroundColor: "#EAECEF",
                          }}
                          disabled
                          // InputProps={{
                          //     readOnly: true,
                          //   }}
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.grandTotal}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                      sx={{ width: 80 }}
                      type="button"
                      variant="outlined"
                      style={{
                        color: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                      }}
                      onClick={() => handleCloseDialog()}
                    >
                      close
                    </Button>
                    <Button
                      sx={{ width: 80 }}
                      type="submit"
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                      }}
                      disabled={!formik.values.qty}
                      onClick={() => handleSaveDialog()}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>
              {detailList.length > 0 ? (
                <Grid item xs={12}>
                  <TableContainer
                    sx={{
                      marginTop: 2,
                      // marginBottom: 2,
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">#</TableCell>
                          <TableCell align="center">รายการ</TableCell>
                          <TableCell align="center">ประเภทตู้</TableCell>
                          <TableCell align="center">ค่าบริการ/ตู้</TableCell>
                          <TableCell align="center">ระบุจำนวนตู้</TableCell>
                          <TableCell align="center">ราคารวม</TableCell>
                          <TableCell align="center">Vat</TableCell>
                          <TableCell align="center">ราคาหลังรวม Vat</TableCell>
                          <TableCell align="center"> </TableCell>
                        </TableRow>
                      </TableHead>
                      {detailList
                        ?.filter((x) => !x.delete)
                        .map((data, index) => {
                          return (
                            <TableBody>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="left" width="25%">
                                {/* {data.PriceNo || data?.Serviceno} */}
                                {data?.Servicename}
                              </TableCell>
                              <TableCell align="center">
                                {data.ContainerTypeName}
                              </TableCell>
                              <TableCell align="right">{data.amount}</TableCell>
                              <TableCell align="center">{data.qty}</TableCell>
                              <TableCell align="right">{data.total}</TableCell>
                              <TableCell align="right">
                                {data.Vatvalue}%
                              </TableCell>
                              <TableCell align="right">
                                {data.grandTotal}
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: "#FF0000",
                                    borderColor: "#FF0000",
                                  }}
                                  onClick={() => handleDeleteRow(data, index)}
                                  disabled={
                                    StatusQuo == 0 ||
                                    StatusQuo == 2 ||
                                    StatusQuo == 3
                                  }
                                >
                                  ลบ
                                </Button>
                              </TableCell>
                            </TableBody>
                          );
                        })}
                    </Table>
                  </TableContainer>
                  <table
                    style={{
                      width: "100%",
                      textAlign: "right",
                      border: "1px solid #e0e0e0",
                      position: "sticky",
                    }}
                  >
                    <tr
                      style={{
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <td style={{ width: "75%" }}>ค่าบริการทั้งหมด :</td>
                      <td style={{ width: "25%" }}>
                        <h4>
                          {SUM &&
                            SUM?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </h4>
                      </td>
                    </tr>
                    {/* <tr
                    style={{
                      borderBottom: "1px solid #e0e0e0",
                      color: "red",
                    }}
                  >
                    <td style={{ width: "75%" }}>รวมส่วนลด :</td>
                    <td style={{ width: "25%" }}>
                      <h4>
                        {Discount &&
                          Discount?.toFixed(2).replace(
                            /\d(?=(\d{3})+\.)/g,
                            "$&,"
                          )}
                      </h4>
                    </td>
                  </tr> */}
                    <tr
                      style={{
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <td style={{ width: "75%" }}>ราคาหลังรวม VAT :</td>
                      <td style={{ width: "25%", color: "green" }}>
                        <h4>
                          {/* {PriceDiscount &&
                          PriceDiscount?.toFixed(2)
                         }
                       */}
                          {parseFloat(PriceDiscount)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          {/* {PriceDiscount?.replace(/\d(?=(\d{3})+\.)/g, "$&,")} */}
                        </h4>
                      </td>
                    </tr>
                  </table>
                </Grid>
              ) : null}

              <Grid item xs={12} sx={{ marginTop: 5 }}>
                <TextField
                  multiline
                  fullWidth
                  rows={4}
                  name="note"
                  label="Internal note"
                  variant="outlined"
                  disabled={StatusQuo == 0 || StatusQuo == 2 || StatusQuo == 3}
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formik.values.note}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={8} sm={12} sx={{ marginTop: 5 }}>
                <Button
                  sx={{ width: 80 }}
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  Cancel
                </Button>
                {StatusQuo == 2 ? (
                  <Button
                    sx={{ width: 80 }}
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={() => changeStatusButton(3)}
                  >
                    {Submitting && <CircularProgress size={22} />}
                    {!Submitting && "DONE"}
                  </Button>
                ) : StatusQuo == 0 ? null : (
                  <Button
                    sx={{ width: 80 }}
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    // disabled={
                    //   !formik.values.customer.cusId ||
                    //   !formik.values.serviceRoute.locationFrom ||
                    //   !formik.values.serviceRoute.groupFrom ||
                    //   !formik.values.serviceRoute.locationTo ||
                    //   !formik.values.serviceRoute.groupTo ||
                    //   detailList.length === 0 ||
                    //   FacList.length === 0
                    // }
                  >
                    {Submitting && <CircularProgress size={22} />}
                    {!Submitting && "SAVE"}
                  </Button>
                )}
                {id && StatusQuo == 1 ? (
                  <>
                    <Button
                      sx={{ width: 80 }}
                      variant="contained"
                      style={{
                        background: "#F53C56",
                        borderColor: "#F53C56",
                        marginRight: "10px",
                      }}
                      onClick={() => changeStatusButton(0)}
                    >
                      {Submitting && <CircularProgress size={22} />}
                      {!Submitting && "REJECT"}
                    </Button>
                    <Button
                      sx={{ width: 80 }}
                      variant="contained"
                      style={{
                        background: "#007BFF",
                        borderColor: "#007BFF",
                        marginRight: "10px",
                      }}
                      onClick={() => changeStatusButton(2)}
                    >
                      {Submitting && <CircularProgress size={22} />}
                      {!Submitting && "APPROVE"}
                    </Button>
                  </>
                ) : null}
                {/* {id && StatusQuo == 2 ? (
                <Button
                  variant="outlined"
                  style={{
                    color: "white",
                    borderColor: "orange",
                    backgroundColor: "orange",
                    marginRight: "10px",
                  }}
                  onClick={() => saveEditFactory()}
                >
                  save Factory
                </Button>
              ) : null} */}
                {id && StatusQuo !== "" ? (
                  <Button
                    variant="outlined"
                    style={{
                      background: "#fff",
                      borderColor: "#C8C8C8",
                    }}
                    onClick={async () => {
                      setLoading(true);
                      const BranchName = branchData?.find((item) => item?.BranchId === branch)?.BranchName
                      const BranchCode = BranchName?.includes('Kantang') ? 'Kantang' :  BranchName?.includes('Hatyai') ? 'Hatyai' : 'Head Office'
                      await api
                        .get(
                          `api/report/quotation/download/pdf?QuotationId=${QuotationId}&BranchCode=${BranchCode}`,
                          {
                            responseType: "blob",
                            timeout: 30000,
                          }
                        )
                        .then((blobFile) => {
                          const blobFileRes = new File(
                            [blobFile?.data],
                            "test.pdf",
                            {
                              type: mime.getType(".pdf"),
                            }
                          );

                          // window.open(
                          //   URL.createObjectURL(blobFileRes, "test.csv"),
                          //   "_blank"
                          // );
                          saveAs(blobFileRes, "Reportquotation.pdf");
                          setLoading(false);
                        });
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={22} />
                    ) : (
                      <Typography sx={{ color: "#8E8C8C" }}>Print</Typography>
                    )}
                  </Button>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </form>
        )}
      </Card>
    </div>
  );
}
